import login_logo from "../assets/logo.png";
const IMAGES = {
  login_logo: login_logo,
};

export default IMAGES;
